export default __webpack_public_path__ + "static/media/car-g.1cedd856.png";